<h1 mat-dialog-title>Izloguj se</h1>
<mat-dialog-content>
  <div>Da li ste sigurni da želite da se izlogujete?</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" mat-dialog-close>Otkaži</button>
  <button mat-flat-button color="primary" type="submit" mat-dialog-close (click)="logout()">Potvrdi</button>
</mat-dialog-actions>
